<!-- Responsibility: Manage admin feature flags.
Scope: View-only card for admin feature flags state. -->
<admin-feature-flags-card>
  <section class="admin-card">
    <header>
      <h2>Feature Flags</h2>
      <span class="admin-card-meta">Live runtime policy and access controls.</span>
    </header>
    <p class="admin-copy">Control global maintenance mode, user registration, AI provider overrides, and managed logic/image quotas.</p>
    
    <div ref="flagsHost" class="admin-form-host"></div>
    
    <div class="admin-actions">
      <button type="button" class="action-btn primary" onclick={ saveFlags }>SAVE FLAGS</button>
      <button type="button" class="action-btn" onclick={ resetFlags }>RESET</button>
    </div>
  </section>

  <script>
    import { AutoForm, collectValues, populateFields } from 'field-assist'
    import { adminService } from '../../../services/admin-service.ts'
    import {
      buildAdminFlagInitialValues,
      buildAdminFlagsFormMeta,
      buildAdminFlagSubmission,
    } from '../../helpers/admin-flags-form.ts'

    export default {
      onMounted() {
        this.renderFlagsForm()
      },

      onUpdated() {
        this.renderFlagsForm()
      },

      renderFlagsForm() {
        if (!this.props.flags) return
        const host = this.$('[ref="flagsHost"]')
        if (!(host instanceof HTMLElement)) return
        host.replaceChildren()
        const initialValues = buildAdminFlagInitialValues(this.props.flags)
        const autoForm = new AutoForm(buildAdminFlagsFormMeta())
        autoForm.render(initialValues, host)
        populateFields(host, initialValues, 'name')
      },

      async saveFlags() {
        const host = this.$('[ref="flagsHost"]')
        if (!(host instanceof HTMLElement)) return
        const values = collectValues(host, undefined, 'name')
        const submission = buildAdminFlagSubmission(values, this.props.flags)
        await adminService.saveFlags(submission)
      },

      resetFlags() {
        this.renderFlagsForm()
      }
    }
  </script>

  <style>
    .admin-card {
      display: grid;
      gap: var(--space-sm);
      border: 1px solid color-mix(in srgb, var(--border) 46%, transparent);
      border-radius: 1rem;
      padding: var(--space-md);
      background: var(--surface-raised);
      box-shadow: var(--shadow-elev-2);
    }

    header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      gap: var(--space-sm);
    }

    h2 {
      margin: 0;
      color: var(--text-prose);
    }

    .admin-card-meta {
      font-size: var(--type-xs);
      color: var(--text-muted);
    }

    .admin-copy {
      color: var(--text-muted);
      font-size: var(--type-sm);
      margin: 0;
    }

    .admin-form-host {
      display: grid;
      gap: var(--space-sm);
      padding: var(--space-sm) 0;
    }

    .admin-actions {
      display: flex;
      gap: var(--space-sm);
      justify-content: flex-end;
    }
  </style>
</admin-feature-flags-card>
